import { render } from "./DetailItemModal.vue?vue&type=template&id=1c3bace6&scoped=true"
import script from "./DetailItemModal.vue?vue&type=script&lang=js"
export * from "./DetailItemModal.vue?vue&type=script&lang=js"

import "./DetailItemModal.vue?vue&type=style&index=0&id=1c3bace6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c3bace6"]])

export default __exports__